import { RootState } from '../store';

export const selectIsAuthenticated = (state: RootState) =>
  !!state.user.tokens?.accessToken;
